import { render } from "./DepositoDashboard.vue?vue&type=template&id=6acd0f3f&scoped=true"
import script from "./DepositoDashboard.vue?vue&type=script&lang=js"
export * from "./DepositoDashboard.vue?vue&type=script&lang=js"

import "./DepositoDashboard.vue?vue&type=style&index=0&id=6acd0f3f&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acd0f3f"]])

export default __exports__